import React from 'react';
import styled from 'styled-components';
import { Body5, Container } from '@ui';
import { FilterableDocumentsContext } from '@/contexts/FilterableDocumentsContext';
import {
  REPORTING_PERIOD_AVAILABLE_TYPES,
  ReportingPeriodFilter,
} from '@containers/DigitalAnalyst/components/ReportingPeriodFilter';

const Wrapper = styled.div``;
const FilterButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
`;

const noneType = 'None';

export const ReportingPeriodSelectBar = () => {
  const { reportingPeriodTypes, applyFilter } = React.useContext(FilterableDocumentsContext);

  const [activeReportingPeriodType, setActiveReportingPeriodType] = React.useState({
    quarter: '',
    month: '',
    year: '',
  });

  const handleReportingPeriodChange = (reportingPeriodType, value) => {
    const nextState = { ...activeReportingPeriodType, [reportingPeriodType]: value };
    setActiveReportingPeriodType(nextState);
    applyFilter({ activeReportingPeriod: nextState });
  };

  if (!Object.values(reportingPeriodTypes).some((v) => v.length > 0)) {
    return null;
  }

  return (
    <Wrapper>
      <Container bottom={12}>
        <Body5>Reporting Periods</Body5>
      </Container>
      <FilterButtonsWrapper>
        {REPORTING_PERIOD_AVAILABLE_TYPES.map((reportingPeriodType) =>
          reportingPeriodTypes[reportingPeriodType]?.length > 0 ? (
            <ReportingPeriodFilter
              key={reportingPeriodType}
              reportingPeriodType={reportingPeriodType}
              options={reportingPeriodTypes[reportingPeriodType]}
              value={activeReportingPeriodType[reportingPeriodType] || noneType}
              onChange={handleReportingPeriodChange}
            />
          ) : null
        )}
      </FilterButtonsWrapper>
    </Wrapper>
  );
};
